export const isMagicDrawerOpen = state => state.drawerOpen



// WEBPACK FOOTER //
// ./src/redux/reducers/uiSelector.js